<template>
  <div class="OrderDetcontent">
    <van-row class="billDetail" v-if="orderDetail.address">
      <van-col span="24" class="cont">
        <van-col span="24" class="address">{{orderDetail.address}}</van-col>
        <van-col span="12" class="name">{{orderDetail.name}}</van-col>
        <van-col span="12" class="phone">{{orderDetail.phone}}</van-col>
      </van-col >
      <van-col span="24" class="statusText" v-if="orderDetail.status == '0'">待接单</van-col>
      <van-col span="24" class="statusText" v-if="orderDetail.status == '1,5,6,7'">维修中</van-col>
      <van-col span="24" class="statusText" v-if="orderDetail.status == '10'">已完成</van-col>
    </van-row>
    <van-row class="billDetail" v-if="orderDetail.address">
      <van-col span="24" class="cont">
        <van-col span="4">订单号</van-col>
        <van-col span="20" class="orderId">{{orderDetail.id}}</van-col>
      </van-col >
      <van-col span="6" class="time">报修时间</van-col>
      <van-col span="18" class="timeB">{{orderDetail.createTime}}</van-col>
    </van-row>
    <van-row class="billDetail" v-if="orderDetail.address">
      <van-col span="24">
        <van-col span="24" class="title">报修描述</van-col>
        <van-col span="24" class="reason">{{orderDetail.reason}}</van-col>
      </van-col >
      <van-col span="24" class="imgBox">
        <img :src="img" alt="报修图" v-for="(img,index) in orderDetail.imageurls" :key="index" @click="ImagePreviewShow(orderDetail.imageurls,index)">
       </van-col>
    </van-row>
  </div>
</template>

<script>
  import { ImagePreview } from 'vant';
	export default {
    name:"orderdetail",
	  data(){
	    return{
        orderDetail:{},
      }
    },
    created(){
      this.orderDetail = this.$cookies.get('repairorderInfo');
      console.log(this.orderDetail);
    },
    methods:{
      /*
      * 预览图片
      * */
      ImagePreviewShow(img,index){
        ImagePreview({
          images:img,
          startPosition:index,
          showIndicators:true
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" >
  @import "../../common/stylus/mixins.styl"
  .OrderDetcontent
    padding 10px 0px
    .billDetail
      display block
      padding 30px 40px
      background #fff
      border-top 20px solid #f9f9f9
      .van-row
        padding-left 25px
      .cont
        border-bottom 2px solid #f0f0f0
        font-size 28px
        color #888888
        padding 20px 0px
      .address
        font-size 30px
        color #222222
        line-height 40px
        padding 0px 0px 20px
      .phone
        text-align right
      .time
        padding 20px 0px
        font-size 28px
        color #888888
      .orderId
        padding-left 10px
      .timeB
        text-align right
        padding 20px 0px
        font-size 28px
        color #888888
      .statusText
        padding-top 20px
        font-size 28px
        color #888888
      .title
        font-size 30px
        color #333
        padding 20px 0px
      .reason
        padding 20px 20px
        color #999
        line-height 30px
      .imgBox
        padding 20px 0px
        img
          margin 6px 3px
          width 150px
          height 150px
</style>



// WEBPACK FOOTER //
// src/pages/repairOrder/repairOrderDetail.vue